<template>
    <form class="row trade-in g-3" v-on:submit.prevent="SubmitTradeIn">
        <template v-if="this.submitSuccess===true">
            <div class="col-12">
                <span class="success">{{this.tradeInSuccess}}</span>
            </div>
        </template>
        <template v-if="this.submitFailure===true">
            <div class="col-12">
                <span class="failure">{{this.inputFormSubmitFailure}}</span>
            </div>
        </template>
        <template v-if="!this.submitSuccess">
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="year"
                               placeholder=" "
                               v-model="v$.leadObj.current_Boat_Year__c.$model"
                               @blur="v$.leadObj.current_Boat_Year__c.$touch()" />
                        <label for="year" class="form-label">{{formLabel.year}}</label>
                        <div class="error">
                            <template v-if="v$.leadObj.current_Boat_Year__c.$error">
                                <span v-for="(err, index) in v$.leadObj.current_Boat_Year__c.$errors" :key="index" class="error text-danger validate">
                                    {{ err.$message }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="model"
                               placeholder=" "
                               v-model="v$.leadObj.current_Boat_Model__c.$model"
                               @blur="v$.leadObj.current_Boat_Model__c.$touch()" />
                        <label for="model" class="form-label">{{formLabel.model}} </label>
                        <div class="error">
                            <template v-if="v$.leadObj.current_Boat_Model__c.$error">
                                <span v-for="(err, index) in v$.leadObj.current_Boat_Model__c.$errors" :key="index" class="error text-danger validate">
                                    {{ err.$message }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="make"
                               placeholder=" "
                               v-model="leadObj.current_Boat_Make__c" />
                        <label for="make" class="form-label">{{formLabel.make}} </label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="hin"
                               placeholder=" "
                               v-model="leadObj.current_Boat_HIN__c" />
                        <label for="hin" class="form-label">Hull # </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <textarea type="text"
                                  class="form-control form-textarea"
                                  rows="3"
                                  id="additionalInfo"
                                  placeholder=" "
                                  v-model="leadObj.additional_Information__c" />
                        <label for="additionalInfo" class="form-label">{{formLabel.additionalInfo}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h2>{{formLabel.yourInformation}}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="fname"
                               placeholder=" "
                               v-model="v$.leadObj.firstName.$model"
                               @blur="v$.leadObj.firstName.$touch()" />
                        <label for="fname" class="form-label">{{formLabel.firstName}}</label>
                        <div class="error">
                            <template v-if="v$.leadObj.firstName.$error">
                                <span v-for="(err, index) in v$.leadObj.firstName.$errors" :key="index" class="error text-danger validate">
                                    {{ err.$message }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="lname"
                               placeholder=" "
                               v-model="v$.leadObj.lastName.$model"
                               @blur="v$.leadObj.lastName.$touch()" />
                        <label for="lname" class="form-label">{{formLabel.lastName}}</label>
                        <div class="error">
                            <template v-if="v$.leadObj.lastName.$error">
                                <span v-for="(err, index) in v$.leadObj.lastName.$errors" :key="index" class="error text-danger validate">
                                    {{ err.$message }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="email"
                               class="form-control"
                               id="email"
                               placeholder=" "
                               v-model="v$.leadObj.email.$model"
                               @blur="v$.leadObj.email.$touch()" />
                        <label for="email" class="form-label">{{formLabel.email}}</label>
                        <div class="error">
                            <template v-if="v$.leadObj.email.$error">
                                <span v-for="(err, index) in v$.leadObj.email.$errors" :key="index" class="error text-danger validate">
                                    {{ err.$message }}
                                </span>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <input type="tel"
                               class="form-control"
                               id="phone"
                               placeholder=" "
                               v-model="leadObj.phone" />
                        <label for="phone" class="form-label">{{formLabel.phone}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <input type="text"
                               class="form-control"
                               id="address"
                               placeholder=" "
                               v-model="leadObj.street" />
                        <label for="address" class="form-label">{{formLabel.streetAddress}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="text"
                                           class="form-control"
                                           id="city"
                                           placeholder=" "
                                           v-model="leadObj.city" />
                                    <label for="city" class="form-label">{{formLabel.city}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <states-dropdown :CountryCode="this.country"
                                           v-model="state"
                                           :onchange="selectedState"
                                           id="state" />
                                    <label for="state" class="form-label">{{formLabel.state}}</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text"
                                           class="form-control"
                                           id="zipcode"
                                           placeholder=" "
                                           v-model="leadObj.postalCode" />
                                    <label for="zipcode" class="form-label">{{formLabel.zipcode}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <country-dropdown v-model="country"
                                             :oncountryload="InitialSelect"
                                             :onchange="selectedCountry" />
                                    <label for="country" class="form-label">{{formLabel.country}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <textarea type="text"
                                  class="form-control form-textarea"
                                  rows="7"
                                  id="message"
                                  placeholder=" "
                                  v-model="leadObj.message__c" />
                        <label for="message" class="form-label">{{formLabel.message}}</label>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <button class="btn-submit" value="Submit" type="submit" :disabled="isSubmitting">{{formLabel.submit}}</button>
            </div>
            <div class="hidden">
                <input type="hidden"
                       id="TRADE_IN_LEAD_SOURCE"
                       name="TRADE_IN_LEAD_SOURCE"
                       v-model="leadSource" />
                <input type="hidden"
                   id="loading-time"
                   name="loading-time"
                   :value="this.unixTimestamp" />
                <input type="text"
                   style="display: none"
                   id="hpValue"
                   name="hpValue"
                   v-model="hpvalue" />
            </div>            
        </template>
    </form>
</template>
<script>
    import CountryDropdown from "../atoms/CountryDropdown.vue";
    import StatesDropdown from "../atoms/StatesDropdown.vue";
    import getEndPoint, { leadAPI } from "../../constants/api.config";
    import { salesforcelead } from "../../constants/form-model-config";
    import useValidate from "@vuelidate/core";
    import {inputFormSubmitFailure, tradeInSuccess, formLabel} from '../../constants/labels.config';
    import {
        required,
        email,
        helpers,
    } from "@vuelidate/validators";
    export default {
        name: "TradeIn",
        components: {
            CountryDropdown,
            StatesDropdown,
        },
        data() {
            return {
                v$: useValidate(),
                state: "",
                country: "",
                requestTime: "",
                hpvalue: "",
                leadID:"",
                leadSource: "Trade In",
                leadObj: { ...salesforcelead },
                submitSuccess:false,
                submitFailure:false,
                inputFormSubmitFailure,
                tradeInSuccess,
                isSubmitting:null,
                formLabel
            };
        },
        validations() {
            return {
                leadObj:{
                    firstName: {
                        required: helpers.withMessage("First name required", required),
                    },
                    lastName: {
                        required: helpers.withMessage("Last name required", required),
                    },
                    email: {
                        required: helpers.withMessage(
                            "Email address required",
                            required
                        ),
                        email: helpers.withMessage("Invalid email address", email),
                    },
                    current_Boat_Year__c: {
                        required: helpers.withMessage("Year required", required),
                    },
                    current_Boat_Model__c: {
                        required: helpers.withMessage("Model required", required),
                    }
                }
            };
        },
        computed: {
            unixTimestamp: function () {
                return Math.round(new Date().getTime() / 1000);
            },
            getMaxDate: function () {
                const dt = new Date();
                dt.setMonth(dt.getMonth() + 1);
                return dt.toISOString().split("T")[0];
            },
        },
        methods: {
            selectedCountry: function (event) {
                this.country = event.target.value;
            },
            InitialSelect: function (data) {
                this.country = data;
            },
            selectedState: function (event) {
                this.state = event.target.value;
            },
            SubmitTradeIn(e) {

                this.submitSuccess=false;
                this.submitFailure=false;
                this.isSubmitting=true;
                this.v$.$validate();
                if (this.v$.$error) {
                    this.isSubmitting=false;
                    for (var i = 0; i < this.v$.$errors.length;i++) {
                        console.log(this.v$.$errors[i].$message);
                    }                    
                    return;
                }
                
                this.leadObj.state = this.state != "" ? this.state : document.getElementById("state").value;
                this.leadObj.country = this.country;
                this.leadObj.leadSource = this.leadSource;
                this.leadObj.honeyPot = this.hpvalue;
                this.leadObj.requestTime = document.getElementById("loading-time").value;                
                console.log(this.leadObj);

                this.axios
                    .post(getEndPoint(leadAPI), this.leadObj)
                    .then((response) => {
                        this.leadID = response.data.id; 
                        this.submitSuccess=true;
                        this.submitFailure=false;
                        this.isSubmitting = false;
                    })
                    .catch((error) => {
                        this.submitFailure=true;
                        this.submitSuccess=false;
                        this.isSubmitting = false;
                        console.error("There was an error!", error);
                    });
                e.preventDefault();
            },
        },
    };
</script>